export default __webpack_public_path__ + "static/poster-d092ad0ed9adbb67e07611c742d957d8.png";